module.exports = __webpack_public_path__ + "static/media/war-ev-large.54464b78.jpg";